/** Put `item` back at `index`, clamped to the end of the list. Same id is a no-op. */
export function reinsertItem<T extends { id: string }>(
  items: T[],
  item: T,
  index: number
): T[] {
  if (items.some((existing) => existing.id === item.id)) return items;
  const at = Math.min(Math.max(index, 0), items.length);
  return [...items.slice(0, at), item, ...items.slice(at)];
}
